import { render, staticRenderFns } from "./DonatePopup.vue?vue&type=template&id=3b265afb&scoped=true&"
import script from "./DonatePopup.vue?vue&type=script&lang=js&"
export * from "./DonatePopup.vue?vue&type=script&lang=js&"
import style0 from "./DonatePopup.vue?vue&type=style&index=0&id=3b265afb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b265afb",
  null
  
)

export default component.exports